"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2539],{

/***/ 71891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ ConnectMenu; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(38509);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49839);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(89513);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/app/useCurrentUser.ts
var useCurrentUser = __webpack_require__(29635);
// EXTERNAL MODULE: ./src/classes/plate/Plate.ts + 13 modules
var Plate = __webpack_require__(75696);
// EXTERNAL MODULE: ./src/classes/utilities/Toaster.tsx
var Toaster = __webpack_require__(42917);
;// CONCATENATED MODULE: ./src/components/Shared/ConnectMenu/PlateTitle.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function PlateTitle(param) {
    var plate = param.plate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageTitle, {
        isPublic: plate.snapshot.isPublic,
        children: [
            plate.snapshot.title,
            !plate.snapshot.currentUserIsOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedPageOwner, {
                children: plate.snapshot.owner.username
            })
        ]
    });
}
var PageTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9b154bc-0"
})(_templateObject(), function(param) {
    var theme = param.theme, isPublic = param.isPublic;
    return isPublic ? theme.text.default : theme.accent;
});
var SharedPageOwner = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9b154bc-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
});

// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/PageScreenshot.tsx + 1 modules
var PageScreenshot = __webpack_require__(76468);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14129);
// EXTERNAL MODULE: ./src/components/UI/Menus/utils.ts
var utils = __webpack_require__(7411);
// EXTERNAL MODULE: ./src/lib/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(80521);
;// CONCATENATED MODULE: ./src/components/UI/Menus/BorderControl.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function BorderControl_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n"
    ]);
    BorderControl_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BorderControl = function(param) {
    var children = param.children;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)({}), position = ref1[0], setPosition = ref1[1];
    var ref2 = (0,react.useState)(false), reversed = ref2[0], setReversed = ref2[1];
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        if (!ref.current || !ref.current.parentElement) return;
        var anchor = ref.current.parentElement.getBoundingClientRect();
        var dimensions = ref.current.getBoundingClientRect();
        var ref1 = (0,utils/* borderControl */.u)({
            anchor: anchor,
            dimensions: dimensions,
            reversed: reversed
        }), shouldReverse = ref1.shouldReverse, menuPosition = ref1.menuPosition;
        setReversed(shouldReverse);
        setPosition(menuPosition);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        ref: ref,
        style: (0,_object_spread/* default */.Z)({}, position),
        children: children
    });
};
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfeff73c-0"
})(BorderControl_templateObject());

// EXTERNAL MODULE: ./src/components/UI/Menus/Menu.tsx
var Menu = __webpack_require__(54871);
// EXTERNAL MODULE: ./src/components/UI/Menus/MenuItem/MenuItem.tsx
var MenuItem = __webpack_require__(57608);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(30440);
;// CONCATENATED MODULE: ./src/components/Shared/ConnectMenu/ConnectMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function ConnectMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  position: "sticky";\n  top: 0;\n  left: 0;\n  padding: 7px 7px;\n  width: 100%;\n  background-color: ',
        ";\n"
    ]);
    ConnectMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConnectMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  padding: 7px 10px;\n  outline: none;\n  border: ",
        ";\n  width: 100%;\n  transition: 0.2s all;\n  :hover {\n    background: ",
        ";\n  }\n  :focus {\n    background: ",
        ";\n  }\n"
    ]);
    ConnectMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












/**
 * A cleaned up version of ConnectMenu. Only for Plates for now.
 */ function ConnectMenu(param) {
    var _closeMenu = param.closeMenu, closeMenu = _closeMenu === void 0 ? function() {} : _closeMenu, block = param.block, plate = param.plate, blockMouseEvents = param.blockMouseEvents;
    var ref = (0,react.useRef)(null);
    var user = (0,useCurrentUser/* useCurrentUser */.x)();
    var ref1 = (0,react.useState)(""), query = ref1[0], setQuery = ref1[1];
    var ownPlates = user.observe(function(state) {
        return state.plates;
    });
    var sharedPlates = user.observe(function(state) {
        return state.sharedPlates;
    });
    var forbiddenConnectionIds = block ? block.forbiddenConnectionIds : plate ? [
        plate.snapshot.id
    ] : [];
    var plates = (0,_to_consumable_array/* default */.Z)(ownPlates).concat((0,_to_consumable_array/* default */.Z)(sharedPlates)).filter(function(p) {
        return !forbiddenConnectionIds.includes(p.snapshot.id);
    });
    var queryIsPlateTitle = plates.some(function(p) {
        return p.snapshot.title === query;
    });
    var handleConnect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(passedPlate) {
            var toPlate;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(queryIsPlateTitle && !passedPlate)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", Toaster/* Toaster.error */.x.error("You already have a plate with that title"));
                    case 2:
                        if (!(!passedPlate && !query)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", Toaster/* Toaster.error */.x.error("Please enter a title or select a plate"));
                    case 4:
                        toPlate = passedPlate;
                        if (toPlate) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 8;
                        return Plate/* Plate.create */.h.create(query);
                    case 8:
                        _ctx.t0 = _ctx.sent;
                        if (_ctx.t0) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.t0 = null;
                    case 11:
                        toPlate = _ctx.t0;
                        if (toPlate) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        if (block) {
                            block.connect(toPlate);
                        } else if (plate) {
                            plate.connect(toPlate);
                        }
                        closeMenu();
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConnect(passedPlate) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (ref.current) {
            // this stops a weird behavior in safari where the input field scrolls to the top of the page
            ref.current.focus({
                preventScroll: true
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
        close: closeMenu,
        blockMouseEvents: blockMouseEvents,
        style: {
            maxHeight: "365px",
            overflowY: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWrapper, {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuSearch, {
                    placeholder: "Search or create...",
                    onChange: function(e) {
                        return setQuery(e.target.value);
                    },
                    ref: ref
                })
            }),
            plates.map(function(toPlate) {
                return (!query || toPlate.snapshot.title.toLowerCase().includes(query.toLowerCase())) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                    handleClick: function() {
                        return handleConnect(toPlate);
                    },
                    hoverComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderControl, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageScreenshot/* PageScreenshot */.Y9, {
                            plate: toPlate,
                            styles: {
                                width: "".concat(constants/* DEFAULT_THUMBNAIL_WIDTH */.dg, "px")
                            }
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateTitle, {
                        plate: toPlate
                    })
                }, toPlate.snapshot.id);
            }),
            query && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                handleClick: function() {
                    return handleConnect(null);
                },
                style: {
                    color: queryIsPlateTitle ? "gray" : "#006f6f"
                },
                children: 'Create "'.concat(query, '"')
            })
        ]
    });
}
var SearchWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de70008-0"
})(ConnectMenu_templateObject(), function(param) {
    var theme = param.theme;
    return theme.background;
});
var StyledMenuSearch = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-5de70008-1"
})(ConnectMenu_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.default;
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.subtleContrast, "}");
}, function(param) {
    var theme = param.theme;
    return theme.subtleContrast;
}, function(param) {
    var theme = param.theme;
    return theme.subtleContrast;
});

;// CONCATENATED MODULE: ./src/components/Shared/ConnectMenu/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 76468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y9": function() { return /* binding */ PageScreenshot; },
  "IM": function() { return /* binding */ PageScreenshotWrapper; },
  "t9": function() { return /* binding */ StyledScreenshotImg; }
});

// UNUSED EXPORTS: COMPUTED_SCREENSHOT_ASPECT_RATIO

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(86524);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
// EXTERNAL MODULE: ./src/components/UI/Tooltip/index.ts + 60 modules
var Tooltip = __webpack_require__(23732);
;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/SourceIcon.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 12px;\n  right: 8px;\n  color: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SourceIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSourceIcon, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            tooltipText: "Origin",
            delayShow: 500,
            children: "[*]"
        })
    });
};
var StyledSourceIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ee00ceb-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/PageScreenshot.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PageScreenshot_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    PageScreenshot_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  aspect-ratio: ",
        "; // ensures the image is rendered the same size even before load completes\n  object-fit: contain;\n  position: relative;\n  border: ",
        ";\n  transition-duration: all 0.2s ease;\n  background-color: ",
        ";\n  &:hover {\n    border-color: ",
        ";\n  }\n  &:active {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: default;\n  width: 150px;\n  aspect-ratio: ",
        ";\n  position: relative;\n  border: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var COMPUTED_SCREENSHOT_ASPECT_RATIO = 120 / 205.41; // from looking at how the images are actually rendered
var PageScreenshot = function(param) {
    var plate = param.plate, handleClick = param.handleClick, styles = param.styles, locked = param.locked, isSourcePage = param.isSourcePage, useBigImage = param.useBigImage;
    var ref;
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return state.globalUI.uiSettings.theme;
    });
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageScreenshotWrapper, {
        children: [
            !locked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScreenshotImg, {
                isPublic: isPublic,
                onClick: handleClick,
                style: styles,
                plateTitle: plate.snapshot.title,
                src: plate.getThumbnailUrl({
                    size: useBigImage ? "big" : "small",
                    theme: theme
                }),
                draggable: false
            }, ((ref = plate.snapshot.screenshotTime) === null || ref === void 0 ? void 0 : ref.toString()) || plate.snapshot.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLockedPage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Locked */.QM, {})
            }),
            isSourcePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceIcon, {})
        ]
    });
};
var PageScreenshotWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78185ddd-0"
})(PageScreenshot_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
});
var StyledScreenshotImg = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs(function(props) {
    return {
        "data-testid": "page-screenshot-".concat(props.plateTitle)
    };
}).withConfig({
    componentId: "sc-78185ddd-1"
})(_templateObject1(), COMPUTED_SCREENSHOT_ASPECT_RATIO, function(param) {
    var theme = param.theme, isPublic = param.isPublic;
    return isPublic ? "2px solid ".concat(theme.primary) : "2px solid ".concat(theme.accent);
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.text.subtle;
}, function(param) {
    var theme = param.theme;
    return theme.block.border;
});
var StyledLockedPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78185ddd-2"
})(_templateObject2(), COMPUTED_SCREENSHOT_ASPECT_RATIO, function(param) {
    var theme = param.theme;
    return "2px solid ".concat(theme.accent);
}, function(param) {
    var theme = param.theme;
    return theme.accent;
}, function(param) {
    var theme = param.theme;
    return theme.background;
});


/***/ }),

/***/ 68644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ PageThumbnail; },
  "q": function() { return /* binding */ PreviewWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(26235);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(40974);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(38509);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(89513);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/app/useCurrentUser.ts
var useCurrentUser = __webpack_require__(29635);
// EXTERNAL MODULE: ./src/components/Shared/ConnectMenu/index.ts + 3 modules
var ConnectMenu = __webpack_require__(71891);
// EXTERNAL MODULE: ./src/components/UI/Alert/index.ts
var Alert = __webpack_require__(69277);
// EXTERNAL MODULE: ./src/components/UI/Menus/Menu.tsx
var Menu = __webpack_require__(54871);
// EXTERNAL MODULE: ./src/components/UI/Menus/MenuItem/MenuBreak.tsx
var MenuBreak = __webpack_require__(22639);
// EXTERNAL MODULE: ./src/components/UI/Menus/MenuItem/MenuItem.tsx
var MenuItem = __webpack_require__(57608);
;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/ContextMenu/ContextMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 










function ContextMenu(param) {
    var plate = param.plate, children = param.children;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var loggedIn = !!currentUser;
    var ref = (0,react.useState)(false), deleteAlertOpen = ref[0], setDeleteAlertOpen = ref[1];
    var isOwner = plate.observe(function(state) {
        return state.currentUserIsOwner;
    });
    var isLiked = plate.observe(function(state) {
        return state.isLiked;
    });
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    var onDeleteAccept = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setDeleteAlertOpen(false);
                        _ctx.next = 3;
                        return currentUser === null || currentUser === void 0 ? void 0 : currentUser.deletePlate(plate);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onDeleteAccept() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDelete = function(e) {
        e.stopPropagation();
        setDeleteAlertOpen(true);
    };
    // controls whether and where the menu is shown
    var ref1 = (0,react.useState)(), anchor = ref1[0], setAnchor = ref1[1];
    var handleContextMenu = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setAnchor({
            top: e.pageY,
            right: e.pageX,
            bottom: e.pageY,
            left: e.pageX
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onContextMenu: handleContextMenu,
                children: children
            }),
            anchor && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
                anchor: anchor,
                close: function() {
                    return setAnchor(null);
                },
                blockMouseEvents: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        condition: !lib/* isElectron */.d,
                        handleClick: plate.openInNewTab,
                        children: "Open in New Tab"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        handleClick: plate.copyLink,
                        children: "Copy Link"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBreak/* MenuBreak */.D, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        condition: loggedIn,
                        handleClick: plate.like,
                        children: isLiked ? "Unlike" : "Like"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        condition: isOwner,
                        handleClick: function() {
                            return plate.changePrivacy();
                        },
                        children: isPublic ? "Make Private" : "Make Public"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        condition: loggedIn,
                        hasSubOptions: true,
                        hoverComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectMenu/* ConnectMenu */.S, {
                            plate: plate,
                            blockMouseEvents: false,
                            block: null
                        }),
                        children: "Add To Plate"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBreak/* MenuBreak */.D, {
                        condition: isOwner
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        condition: isOwner,
                        handleClick: handleDelete,
                        children: "Delete"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                        type: "question",
                        acceptText: "Yes",
                        declineText: "No",
                        onAccept: onDeleteAccept,
                        onDecline: function() {
                            return setDeleteAlertOpen(false);
                        },
                        isOpen: deleteAlertOpen,
                        headerText: "Are you sure you want to delete this plate?",
                        bodyText: "Deleting is a permanent action and cannot be undone."
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/ContextMenu/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/PageScreenshot.tsx + 1 modules
var PageScreenshot = __webpack_require__(76468);
// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/PageThumbnailTitle.tsx
var PageThumbnailTitle = __webpack_require__(5426);
// EXTERNAL MODULE: ./src/components/UI/ConditionalWrapper/ConditionalWrapper.tsx
var ConditionalWrapper = __webpack_require__(87760);
// EXTERNAL MODULE: ./src/components/UI/Links/index.ts
var Links = __webpack_require__(47209);
;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/PageThumbnail.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n  cursor: ",
        ";\n  :hover {\n    text-decoration: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










/**
 * Displays a page screenshot and title
 */ function PageThumbnail(param) {
    var plate = param.plate, filterValue = param.filterValue, wrapperStyles = param.wrapperStyles, disableContextMenu = param.disableContextMenu, truncateTitle = param.truncateTitle, disableLink = param.disableLink, screenshotStyles = param.screenshotStyles, useBigImage = param.useBigImage, disableTitle = param.disableTitle;
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewWrapper, {
        disableLink: disableLink,
        style: wrapperStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
            condition: !disableContextMenu,
            wrapper: function(children) {
                return ContextMenu({
                    plate: plate,
                    children: children
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                        condition: !disableLink,
                        wrapper: function(children) {
                            return lib/* isElectron */.d ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* UnstyledLink */.Ho, {
                                href: plate.internalLink,
                                children: children
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: plate.internalLink,
                                shallow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: children
                                })
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageScreenshot/* PageScreenshot */.Y9, {
                            plate: plate,
                            useBigImage: useBigImage,
                            styles: screenshotStyles
                        })
                    }),
                    !disableTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageThumbnailTitle/* PageThumbnailTitle */.Z, {
                        plate: plate,
                        filterValue: filterValue,
                        shouldTruncate: truncateTitle,
                        disableLink: disableLink,
                        isPublic: isPublic
                    })
                ]
            })
        })
    });
}
var PreviewWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-53248630-0"
})(_templateObject(), function(param) {
    var disableLink = param.disableLink;
    return disableLink ? "default" : "pointer";
}, function(param) {
    var disableLink = param.disableLink;
    return disableLink ? "default" : "underline";
});


/***/ }),

/***/ 5426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageThumbnailTitle; },
/* harmony export */   "k": function() { return /* binding */ StyledPageTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52634);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_truncate__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40974);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48876);
/* harmony import */ var src_components_UI_ConditionalWrapper_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87760);
/* harmony import */ var src_components_UI_Links__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47209);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 5px;\n  font-family: "IBM Plex Mono";\n  text-align: right;\n  color: ',
        ";\n  word-break: break-word;\n  flex-shrink: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var PageThumbnailTitle = function(param) {
    var plate = param.plate, filterValue = param.filterValue, shouldTruncate = param.shouldTruncate, isPublic = param.isPublic, disableLink = param.disableLink;
    var adjustedPageTitle = function() {
        if (filterValue) {
            return plate.snapshot.title.replace(new RegExp(filterValue, "gi"), function(match) {
                return "<mark>".concat(match, "</mark>");
            });
        }
        if (shouldTruncate) {
            return lodash_truncate__WEBPACK_IMPORTED_MODULE_3___default()(plate.snapshot.title, {
                length: 29
            });
        }
        return plate.snapshot.title;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_ConditionalWrapper_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_6__/* .ConditionalWrapper */ .M, {
        condition: !disableLink,
        wrapper: function(children) {
            return react_device_detect__WEBPACK_IMPORTED_MODULE_5__/* .isElectron */ .d ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_7__/* .UnstyledLink */ .Ho, {
                href: plate.internalLink,
                children: children
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: plate.internalLink,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: children
                })
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageTitle, {
            $isPublic: isPublic,
            dangerouslySetInnerHTML: {
                __html: adjustedPageTitle()
            }
        })
    });
};
var StyledPageTitle = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c0a3af8e-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $isPublic = param.$isPublic;
    return $isPublic ? theme.text.default : theme.accent;
});


/***/ }),

/***/ 12539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* reexport safe */ _PageThumbnail__WEBPACK_IMPORTED_MODULE_0__.G; }
/* harmony export */ });
/* harmony import */ var _PageThumbnail__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68644);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 18638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79281);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48876);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7599);
/* harmony import */ var _vienna_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45869);
/* harmony import */ var _vienna_common__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_vienna_common__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63546);
/* harmony import */ var src_components_UI_Buttons_StandardButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79088);
/* harmony import */ var src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51367);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: ",
        ";\n  background-color: rgba(131, 131, 131, 0.304);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  top: -40px;\n  width: 500px;\n  padding: 30px;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: ",
        ";\n  border: 2px solid #494949;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: ",
        ';\n  font-family: "IBM Plex Mono";\n  color: ',
        ";\n  overflow: hidden;\n  transform-origin: top center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  font-weight: 300;\n  font-size: 14px;\n  margin-top: 15px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var Alert = function(param) {
    var className = param.className, headerText = param.headerText, bodyText = param.bodyText, okayText = param.okayText, onOkay = param.onOkay, acceptText = param.acceptText, declineText = param.declineText, onAccept = param.onAccept, onDecline = param.onDecline, _declineDangerous = param.declineDangerous, declineDangerous = _declineDangerous === void 0 ? false : _declineDangerous, type = param.type, isOpen = param.isOpen, closeWithESC = param.closeWithESC, closeWithOutsideClick = param.closeWithOutsideClick, closeWithEnter = param.closeWithEnter, children = param.children;
    var alertRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var safeHeaderText = typeof headerText === "string" ? headerText : "Something went wrong";
    var safeBodyText = typeof bodyText === "string" ? bodyText : "";
    (0,src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_7__/* .useHotkey */ .P)(src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_5__/* .HOTKEYS.ESCAPE */ .LM.ESCAPE, function() {
        if (closeWithESC && isOpen) {
            onDecline ? onDecline() : onOkay && onOkay();
        }
    });
    (0,src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_7__/* .useHotkey */ .P)(src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_5__/* .HOTKEYS.ENTER */ .LM.ENTER, function() {
        if (closeWithEnter && isOpen) {
            onAccept ? onAccept() : onOkay && onOkay();
        }
    });
    (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_3__/* .useOnClickOutside */ .t$)(alertRef, function() {
        if (closeWithOutsideClick && isOpen) {
            onDecline ? onDecline() : onOkay && onOkay();
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundOverlay, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledAlert, {
                className: className,
                ref: alertRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalHeader, {
                        children: safeHeaderText
                    }),
                    safeBodyText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalBody, {
                        children: safeBodyText
                    }),
                    children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalFooter, {
                        id: "cy-alert-options",
                        children: type === "question" && onDecline && onAccept ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Buttons_StandardButton__WEBPACK_IMPORTED_MODULE_6__/* .StandardButton */ .K, {
                                    onClick: onDecline,
                                    highContrast: !declineDangerous,
                                    dangerous: declineDangerous,
                                    styles: {
                                        minWidth: "96px"
                                    },
                                    children: declineText
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Buttons_StandardButton__WEBPACK_IMPORTED_MODULE_6__/* .StandardButton */ .K, {
                                    onClick: onAccept,
                                    styles: {
                                        minWidth: "96px",
                                        marginLeft: "25px"
                                    },
                                    children: acceptText
                                })
                            ]
                        }) : onOkay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Buttons_StandardButton__WEBPACK_IMPORTED_MODULE_6__/* .StandardButton */ .K, {
                            onClick: onOkay,
                            children: okayText
                        })
                    })
                ]
            })
        })
    });
};
/**TODO: abstract this for all modals */ var BackgroundOverlay = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cbb71aa3-0"
})(_templateObject(), _vienna_common__WEBPACK_IMPORTED_MODULE_4__.Layer.OVERLAY);
var StyledAlert = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.div */ .E.div).withConfig({
    componentId: "sc-cbb71aa3-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return "10px 10px ".concat(theme.subtleContrast);
}, function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var ModalFooter = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cbb71aa3-2"
})(_templateObject2());
var ModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-cbb71aa3-3"
})(_templateObject3());
var ModalBody = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-cbb71aa3-4"
})(_templateObject4());


/***/ }),

/***/ 69277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* reexport safe */ _Alert__WEBPACK_IMPORTED_MODULE_0__.b; }
/* harmony export */ });
/* harmony import */ var _Alert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18638);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 54871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Menu; }
/* harmony export */ });
/* unused harmony export ClickInterceptor */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14129);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48876);
/* harmony import */ var _vienna_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45869);
/* harmony import */ var _vienna_common__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_vienna_common__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63546);
/* harmony import */ var src_components_UI_Menus_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7411);
/* harmony import */ var src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51367);
/* harmony import */ var src_lib_hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80521);
/* harmony import */ var src_lib_hooks_useOnMouseDownOutside__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3002);
/* harmony import */ var src_lib_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58289);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  z-index: ",
        ";\n  background-color: ",
        ';\n  font-family: "Inter";\n  font-size: 13px;\n  color: ',
        ";\n  max-width: 285px;\n  min-width: 175px;\n  border: ",
        ";\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: ",
        " - 1; // this is the only place we do z-index math. indicative of this being a weird way to solve the problem it solves\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










/**
 * Renders children, usually <MenuItem>s, occasionally things like a search bar. Positions self within window.
 */ function Menu(param) {
    var children = param.children, close = param.close, style = param.style, anchor = param.anchor, blockMouseEvents = param.blockMouseEvents;
    // positioning
    var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), reversed = ref[0], setReversed = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), position = ref1[0], setPosition = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), nMenuItemSelected = ref2[0], setNMenuItemSelected = ref2[1];
    //closing
    (0,src_lib_hooks_useOnMouseDownOutside__WEBPACK_IMPORTED_MODULE_7__/* .useOnMouseDownOutside */ .V)(menuRef, close);
    // arrow navigation
    (0,src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_5__/* .useHotkey */ .P)(src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_4__/* .HOTKEYS.ESCAPE */ .LM.ESCAPE, close);
    (0,src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_5__/* .useHotkey */ .P)(src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_4__/* .HOTKEYS.ARROW_UP */ .LM.ARROW_UP, function() {
        if (nMenuItemSelected === null) {
            setNMenuItemSelected(0);
            return;
        } else if (nMenuItemSelected > 0) {
            setNMenuItemSelected(nMenuItemSelected - 1);
        }
    });
    (0,src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_5__/* .useHotkey */ .P)(src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_4__/* .HOTKEYS.ARROW_DOWN */ .LM.ARROW_DOWN, function() {
        if (nMenuItemSelected === null) {
            setNMenuItemSelected(0);
            return;
        } else if (nMenuItemSelected < react__WEBPACK_IMPORTED_MODULE_2__.Children.count(children) - 1) {
            setNMenuItemSelected(nMenuItemSelected + 1);
        }
    });
    (0,src_lib_hooks_useHotkey__WEBPACK_IMPORTED_MODULE_5__/* .useHotkey */ .P)(src_components_Hotkeys_hotkeys__WEBPACK_IMPORTED_MODULE_4__/* .HOTKEYS.ENTER */ .LM.ENTER, function() {
        if (nMenuItemSelected !== null) {
            var child = react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(children)[nMenuItemSelected];
            if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child)) {
                child.props.handleClick();
            }
        }
    });
    (0,src_lib_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_8__/* .useWindowResize */ .w)(close);
    // ensure the menu is always on screen
    (0,src_lib_hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        if (!menuRef.current || !menuRef.current.parentElement) return;
        var dimensions = menuRef.current.getBoundingClientRect();
        var ref = (0,src_components_UI_Menus_utils__WEBPACK_IMPORTED_MODULE_9__/* .borderControl */ .u)({
            anchor: anchor || menuRef.current.parentElement.getBoundingClientRect(),
            dimensions: dimensions,
            reversed: reversed
        }), shouldReverse = ref.shouldReverse, menuPosition = ref.menuPosition;
        setReversed(shouldReverse);
        setPosition(menuPosition);
    }, []);
    var childrenWithProps = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child, n) {
        if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child)) {
            //TODO, provide better type than any
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, {
                isSelectedInMenu: n === nMenuItemSelected,
                selectInMenu: function() {
                    return setNMenuItemSelected(n);
                },
                deselectInMenu: function() {
                    return setNMenuItemSelected(null);
                }
            });
        }
        return child;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MenuWrapper, {
                onClick: close,
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, position, style),
                ref: menuRef,
                children: childrenWithProps
            }),
            blockMouseEvents && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ClickInterceptor, {
                onContextMenu: function(e) {
                    return e.preventDefault();
                },
                onMouseDown: close
            })
        ]
    });
}
var MenuWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2fa82d45-0"
})(_templateObject(), _vienna_common__WEBPACK_IMPORTED_MODULE_3__.Layer.WIN_LAYER, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.primary;
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
});
var ClickInterceptor = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2fa82d45-1"
})(_templateObject1(), _vienna_common__WEBPACK_IMPORTED_MODULE_3__.Layer.WIN_LAYER);


/***/ }),

/***/ 22639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ MenuBreak; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function MenuBreak(param) {
    var _condition = param.condition, condition = _condition === void 0 ? true : _condition;
    return condition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBreak, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
}
var StyledBreak = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-95e7505d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.subtleContrast;
});


/***/ }),

/***/ 57608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MenuItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  padding: 7px 10px;\n  cursor: pointer;\n  &.isSelectedInMenu {\n    background-color: ",
        ";\n  }\n  &.hoverIsNotControlled&:hover {\n    background-color: ",
        ";\n  }\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function MenuItem(param) {
    var children = param.children, handleClick = param.handleClick, style = param.style, hoverComponent = param.hoverComponent, hasSubOptions = param.hasSubOptions, isSelectedInMenu = param.isSelectedInMenu, checkmarked = param.checkmarked, selectInMenu = param.selectInMenu, deselectInMenu = param.deselectInMenu, _condition = param.condition, condition = _condition === void 0 ? true : _condition;
    // TODO remove jank, hover should always be controlled by parent
    // This will require a refactor of the menu system
    var hoverIsControlled = selectInMenu && deselectInMenu;
    return condition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        onMouseEnter: function() {
            if (selectInMenu) {
                selectInMenu();
            }
        },
        onMouseLeave: function() {
            if (deselectInMenu) {
                deselectInMenu();
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledMenuItem, {
                onClick: handleClick,
                style: style,
                className: hoverIsControlled ? isSelectedInMenu ? "isSelectedInMenu" : "isNotSelectedInMenu" : "hoverIsNotControlled",
                onMouseDown: function(e) {
                    return e.stopPropagation();
                },
                children: [
                    checkmarked && "✓",
                    children,
                    hasSubOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledArrow, {
                        children: ">"
                    })
                ]
            }),
            isSelectedInMenu && hoverComponent
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
}
var StyledArrow = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-cbca76f-0"
})(_templateObject());
var StyledMenuItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cbca76f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.button.hover;
}, function(param) {
    var theme = param.theme;
    return theme.button.hover;
}, function(param) {
    var theme = param.theme;
    return theme.button.active;
});


/***/ }),

/***/ 7411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ borderControl; }
/* harmony export */ });
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ var borderControl = function(param) {
    var anchor = param.anchor, dimensions = param.dimensions, reversed = param.reversed;
    var menuPosition = {};
    var shouldReverse = reversed;
    if (anchor.top + dimensions.height > window.innerHeight) menuPosition.bottom = 0;
    else menuPosition.top = anchor.top - 1;
    if (reversed) {
        if (anchor.left - dimensions.width < 0) {
            menuPosition.left = anchor.right;
            shouldReverse = false;
        } else menuPosition.right = window.innerWidth - anchor.left;
    } else if (anchor.right + dimensions.width > window.innerWidth) {
        menuPosition.right = window.innerWidth - anchor.left;
        shouldReverse = true;
    } else menuPosition.left = anchor.right;
    return {
        menuPosition: menuPosition,
        shouldReverse: shouldReverse
    };
};


/***/ }),

/***/ 80521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44725);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
/**
 * useIsomorphicLayoutEffect: useLayoutEffect for server-side rendering. useLayoutEffect does not run on the server because there's no window,
 * so we can just SSR with a useEffect which won't execute anything (since useEffects run on mount, which happens on the client) but will
 * prevent the very load console warning from showing up. Then we switch to useLayoutEffect on the client where it will actually execute as
 * expected, and won't cause any warnings.
 */ var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
/* harmony default export */ __webpack_exports__["Z"] = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 58289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useWindowResize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44725);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
// Hook
function useWindowResize(handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // function to call on event
        var listener = function() {
            handler();
        };
        // Add event listener
        window.addEventListener("resize", listener);
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener("resize", listener);
        };
    }, []);
}


/***/ })

}]);